import React from 'react';
import { Breadcrumb, BreadcrumbsLink, BreadcrumbsHomeIcon } from '@fiverr-private/navigation';
import { Container } from '@fiverr-private/layout_components';
import { useBusinessListingsContext } from '../Context';
import SidebarTopSection from '../SidebarTopSection';
import ListingsToggle from '../../ListingsToggle';
import styles from '../SidebarTopSection/index.module.scss';

const Header = () => {
    const { isSearch, breadcrumbs, hasItems, isExpertListings } = useBusinessListingsContext();

    const [home, ...steps] = breadcrumbs || [];
    const isNoResults = !hasItems && isExpertListings;

    return (
        <>
            {!isSearch && breadcrumbs && (
                <Breadcrumb marginBottom={'5'}>
                    <BreadcrumbsLink href={home.url}>
                        <BreadcrumbsHomeIcon />
                    </BreadcrumbsLink>
                    {steps.slice(0, -1).map((breadcrumb) => (
                        <BreadcrumbsLink key={breadcrumb.url} href={breadcrumb.url}>
                            {breadcrumb.title}
                        </BreadcrumbsLink>
                    ))}
                </Breadcrumb>
            )}

            {isNoResults && (
                <Container display={{ default: 'none', lg: 'flex' }} marginBottom={'4'} marginTop={'4'}>
                    <div className={`${styles.mainHeaderContent} flex flex-items-center`}>
                        <div className={styles.toggle}>
                            <ListingsToggle isExpertListings={isExpertListings} />
                        </div>
                    </div>
                </Container>
            )}

            <Container display={{ default: 'flex', lg: 'none' }} marginBottom={'4'} marginTop={'4'}>
                <SidebarTopSection />
            </Container>
        </>
    );
};

export default Header;
